import './multirangeslider.css';
import { Outlet } from 'react-router-dom';
import TopNav from './Components/Navigation/TopNav';
import SideNav from './Components/Navigation/SideNav';
import { useAppSelector } from './Reducers/store';
import { UserLevelNames } from './Models/UserLevel';

function App() {
  // const dispatch = useAppDispatch();
  const { userModel } = useAppSelector((state) => state.user);
  // const { manufacturers, categories, subCategories, equipmentSearchData } =
  //   useAppSelector((state) => state.commonFields);

  // const getReferences = async () => {
  //   if (
  //     !manufacturers.length ||
  //     !categories ||
  //     !subCategories ||
  //     !equipmentSearchData
  //   ) {
  //     await Promise.all([
  //       dispatch(fetchManufacturers()),
  //       dispatch(fetchCategories()),
  //       dispatch(fetchSubCategories()),
  //       dispatch(fetchEquipmentSearchData()),
  //     ]);
  //   }
  // };

  // useEffect(() => {
  //   getReferences();
  // }, []);

  return (
    <>
      {/* {manufacturers && equipmentSearchData && ( */}
      <div>
        <TopNav></TopNav>
        <div className='flex h-[calc(100vh-48px)] overflow-y-auto'>
          {userModel && (
            <SideNav isDriver={userModel.userLevelId === UserLevelNames.Driver} />
          )}
          <Outlet></Outlet>
        </div>
        {/* <Footer /> */}
      </div>
      {/* )} */}
    </>
  );
}

export default App;
